/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Audio_Description_Rephrase_Failed_ToastInputs */

const en_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to rephrase text. ${i?.message}`)
};

const fr_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la reformulation du texte. ${i?.message}`)
};

const de_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Textumformulierung fehlgeschlagen. ${i?.message}`)
};

const it_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile riformulare il testo. ${i?.message}`)
};

const ru_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось перефразировать текст. ${i?.message}`)
};

const es_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo reformular el texto. ${i?.message}`)
};

const zh_cn2_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文本重写失败。${i?.message}`)
};

const ja_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`テキストの言い換えに失敗しました。${i?.message}`)
};

const hi_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पाठ को पुनः परिभाषित करने में विफल। ${i?.message}`)
};

const pt_pt2_audio_description_rephrase_failed_toast = /** @type {(inputs: Audio_Description_Rephrase_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível reformular o texto. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to rephrase text. {message}" |
*
* @param {Audio_Description_Rephrase_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_rephrase_failed_toast = /** @type {((inputs: Audio_Description_Rephrase_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Rephrase_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_rephrase_failed_toast(inputs)
	if (locale === "de") return de_audio_description_rephrase_failed_toast(inputs)
	if (locale === "it") return it_audio_description_rephrase_failed_toast(inputs)
	if (locale === "ru") return ru_audio_description_rephrase_failed_toast(inputs)
	if (locale === "es") return es_audio_description_rephrase_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_rephrase_failed_toast(inputs)
	if (locale === "ja") return ja_audio_description_rephrase_failed_toast(inputs)
	if (locale === "hi") return hi_audio_description_rephrase_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_rephrase_failed_toast(inputs)
	return en_audio_description_rephrase_failed_toast(inputs)
});